import {useLocation, useNavigate} from 'react-router-dom';
import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../incase-domain/components/button/Button';
import {type TypedTranslation} from '../../../../../i18n';

const excludedSegments = ['users', 'dashboard', 'messages'];

function Breadcrumbs(): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(Boolean);

    // Find the first index of any excluded segment
    const stopIndex = pathnames.findIndex((segment) => excludedSegments.includes(segment.toLowerCase()));

    // If any excluded segment found, slice pathnames up to and including that segment
    // Otherwise, keep all pathnames
    const filteredPathnames = stopIndex >= 0 ? pathnames.slice(0, stopIndex + 1) : pathnames;

    return (
        <div className="c-breadcrumbs">
            <div className="c-breadcrumbs__item">
                <Button variant="ghost" color="primary" size="sm" leading="solar:home-2-linear" onClick={() => navigate('/')}>
                    {t('navigation.home')}
                </Button>
            </div>
            {filteredPathnames.map((value, index) => {
                const to = `/${filteredPathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === filteredPathnames.length - 1;
                const name = decodeURIComponent(value);

                return (
                    <div className="c-breadcrumbs__item" key={to}>
                        <span className="c-breadcrumbs__separator">/</span>
                        <Button variant="ghost" color="primary" size="sm" onClick={() => navigate(to)}>
                            <div className={isLast ? 'c-breadcrumbs__item--active' : ''}>{t(`navigation.${name}` as TypedTranslation)}</div>
                        </Button>
                    </div>
                );
            })}
        </div>
    );
}

export default Breadcrumbs;
